class ArchiveBeneficiary {
	constructor(
		public readonly facilityId: number,
		public readonly beneficiaryId: number,
		// Raw enum value in ('active' | 'archived'); the server answers with a `{ value, label }` object —
		// the asymmetry is the project's convention, not an inconsistency.
		public readonly status: string,
	) {
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		return {
			status: this.status,
		};
	}
}

export default ArchiveBeneficiary;
